import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class Home6Service {

    api: string = environment.baseUrl;

    constructor(private http: HttpClient) {}


    getHealthCareInsurance = (req: object) => this.http.post<any>(this.api + "InsuranceCompanies/Search", req); 

    getSpecialities = (MedicalServiceId) => this.http.get<any>(this.api + "Speciality?MedicalServiceId=" + MedicalServiceId); 

    getDoctors = (req: object) => this.http.post<any>(this.api + "HcpRequest/search", req); 

    getMedicalServices = () => this.http.get<any>(this.api + "MedicalService"); 
    
    getLatestBlogs = (queryParams: string) => this.http.get<any>(this.api + "Blog?" + queryParams)

    getInitData = () => this.http.get<any>(this.api + "home/InitData?PageSize=9999&PageNumber=1"); 

    homeServices = () => this.http.get<any>(this.api + "MedicalServiceBlog/Search/12/1"); 

    getAllLocations = () => this.http.get<any>(this.api + "Locations/AllLocations");
}